import { Location } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { SubmissionErrorBoundary } from '../../components/errors/SubmissionErrorBoundary';
import { Modal } from '../../components/shared/modal/Modal';
import { EditLocationDetailsForm } from './EditLocationDetailsForm';
import strings from './manageLocation.translations';

interface LocationDetailsModalProps {
  open: boolean;
  onClose: () => void;
  location: Location;
}

export const EditLocationDetailsModal: FC<LocationDetailsModalProps> = ({ open, onClose, location }) => {
  return (
    <Modal open={open} onClose={onClose} header={strings.editLocationDetails.editLabel}>
      <SubmissionErrorBoundary>
        <EditLocationDetailsForm location={location} onComplete={onClose} />
      </SubmissionErrorBoundary>
    </Modal>
  );
};
